import {
  RETRIEVE_OPERATOR_USER_REQUEST,
  RETRIEVE_OPERATOR_USER_SUCCESS,
  RETRIEVE_OPERATOR_USER_FAILURE,
  OPERATOR_USER_CHECKED,
  OPERATOR_USER_EXPANDED,
  SELECT_ALL_OPERATOR_USER,
  DESELECT_ALL_OPERATOR_USER,
} from './types/OperatorUserTypes';

export function retrieveOperatorUserRequestActionCreator(payload, checkedOperatorUsers) {
  return {
    type: RETRIEVE_OPERATOR_USER_REQUEST,
    payload,
    checkedOperatorUsers,
  };
}

export function retrieveOperatorUserSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OPERATOR_USER_SUCCESS,
    payload,
  };
}

export function retrieveOperatorUserFailureActionCreator(error) {
  return {
    type: RETRIEVE_OPERATOR_USER_FAILURE,
    error,
  };
}

export function operatorUserCheckedActionCreator(checkedOperatorUser, reportDefinition) {
  return {
    type: OPERATOR_USER_CHECKED,
    checkedOperatorUser,
    reportDefinition,
  };
}

export function onOperatorUserExpanded(expandedOperatorUser) {
  return {
    type: OPERATOR_USER_EXPANDED,
    expandedOperatorUser,
  };
}

export function onSelectAllOperatorUser(nodes) {
  return {
    type: SELECT_ALL_OPERATOR_USER,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllOperatorUser() {
  return {
    type: DESELECT_ALL_OPERATOR_USER,
  };
}
